import styleVariablesJSON from '../css/styleVariables.json';

const muiTheme = {
  palette: {
    primary: {
      light: '#323232',
      main: styleVariablesJSON['primary-color'],
      dark: '#191919',
      contrastText: '#ffffff',
    },
    secondary: {
      light: '#e8484e',
      main: '#ffc400',
      dark: '#cc181f',
      contrastText: '#fff',
    },
    tertiary: {
      light: '#eeeeee',
      main: '#e7e7e7',
      dark: '#cfcfcf',
    },
  },
  typography: {
    fontFamily: 'Lato-Regular, sans-serif',
    md: {
      fontSize: '1rem',
    },
    body1: {
      md: {
        fontSize: '0.9rem',
      },
    },
    title: {
      fontSize: '40px',
      fontWeight: 300,
    },
    caption: {
      md: {
        fontSize: '0.65rem',
      },
    },
  },
  overrides: {
    MuiButton: {
      root: {
        fontFamily: 'Lato-Regular, sans-serif',
        height: '40px',
        width: 'auto',
        fontSize: '14px',
        borderRadius: '2px',
        md: {
          fontSize: '0.9rem',
          height: '5vh',
        },
        color: styleVariablesJSON['primary-button-text-color'],
      },
      contained: {
        boxShadow: '0px 1px 2px -2px rgb(0 0 0 / 20%)',
      },
      textPrimary: {
        color: styleVariablesJSON.text,
      },
    },
    MuiDialogContent: {
      root: {
        flex: '1 1 auto',
        overflowY: 'visible',
      },
    },
    MuiTabs: {
      indicator: {
        display: 'none',
      },
    },
    MuiTab: {
      root: {
        minWidth: 'unset !important',
        fontSize: '0.8rem',
        fontFamily: 'sans-serif',
      },
      textColorPrimary: {
        color: styleVariablesJSON.text,
      },
      textColorSecondary: {
        color: styleVariablesJSON.text,
      },
    },
    MuiPaper: {
      elevation4: {
        boxShadow: 'none',
      },
      elevation1: {
        boxShadow: 'none',
      },
      root: {
        backgroundColor: 'transparent',
      },
    },
    MuiMenu: {
      paper: {
        backgroundColor: styleVariablesJSON['paper-background-color'],
      },
    },
    MuiNotchedOutline: {
      root: {
        borderStyle: 'none',
        borderBottom: '1px solid #666666',
        borderRadius: '0',
      },
    },
    MuiDialog: {
      paperScrollPaper: {
        backgroundColor: styleVariablesJSON['box-background'],
      },
      paper: {
        margin: '16px',
        'overflow-x': 'hidden',
      },
    },
    MuiList: {
      root: {
        backgroundColor: styleVariablesJSON['box-background'],
      },
      padding: {
        paddingLeft: '1vw',
      },
    },
    MuiListItem: {
      root: {
        margin: '2vh 0',
      },
    },
    MuiListItemIcon: {
      root: {
        minWidth: '36px',
      },
    },
    MuiListItemText: {
      primary: {
        color: styleVariablesJSON.text,
      },
    },
    MuiAppBar: {
      colorPrimary: {
        backgroundColor: styleVariablesJSON['box-background'],
      },
    },
    MuiTypography: {
      body1: {
        color: styleVariablesJSON.text,
      },
    },
    MuiIcon: {
      root: {
        md: {
          fontSize: '1.5rem',
        },
        color: 'inherit',
      },
    },
    MuiIconButton: {
      root: {
        color: styleVariablesJSON.text,
      },
      label: {
        color: 'unset',
      },
    },
    MuiRadio: {
      root: {
        color: styleVariablesJSON['unselected-checkbox'],
      },
      colorSecondary: {
        color: styleVariablesJSON['unselected-checkbox'],
        '&$checked': {
          color: styleVariablesJSON['selected-checkbox'],
        },
      },
    },
    MuiSvgIcon: {
      root: {
        md: {
          fontSize: '1rem',
        },
      },
    },
    MuiCardHeader: {
      root: {},
      md: {
        padding: '4px',
      },
    },
    MuiCheckbox: {
      root: {
        color: styleVariablesJSON['unselected-checkbox'],
      },
      colorSecondary: {
        color: styleVariablesJSON['unselected-checkbox'],
        '&$checked': {
          color: styleVariablesJSON['selected-checkbox'],
        },
        '&.Mui-disabled': {
          color: styleVariablesJSON['unselected-checkbox'],
        },
      },
    },
    MuiInputLabel: {
      formControl: {
        color: styleVariablesJSON['input-text-color'],
      },
      outlined: {
        transform: 'translate(10px, 20px) scale(0.8)',
      },
    },
    MuiInputBase: {
      root: {
        color: styleVariablesJSON['input-text-color'],
        backgroundColor: styleVariablesJSON['input-background-color'],
        'Mui-disabled': {
          color: styleVariablesJSON['disabled-text-color'],
        },
      },
      input: {
        fontSize: '16px',
      },
    },
    MuiOutlinedInput: {
      root: {
        backgroundColor: styleVariablesJSON['input-background-color'],
        color: styleVariablesJSON['input-text-color'],
        borderColor: styleVariablesJSON['input-border-color'],
        borderRadius: styleVariablesJSON['input-border-radius'],
      },
    },
    MuiTableCell: {
      body: {
        borderColor: styleVariablesJSON.text,
        color: styleVariablesJSON.text,
      },
    },
    MuiBadge: {
      colorSecondary: {
        color: styleVariablesJSON['badge-text'],
        backgroundColor: styleVariablesJSON['badge-bg'],
      },
      anchorOriginTopRightRectangle: {
        right: '8px',
      },
    },
    MuiFormHelperText: {
      contained: {
        color: '#ffffff',
      },
    },
    MuiFormControlLabel: {
      label: {
        'Mui-disabled': {
          color: styleVariablesJSON['unselected-checkbox'],
        },
      },
    },
    PrivateTabScrollButton: {
      root: {
        color: styleVariablesJSON.text,
      },
    },
    PrivateTabIndicator: {
      colorSecondary: {
        backgroundColor: styleVariablesJSON['primary-color'],
      },
    },
    MuiStepLabel: {
      completed: {
        color: styleVariablesJSON['primary-color'],
      },
      active: {
        color: styleVariablesJSON['primary-color'],
      },
      color: styleVariablesJSON['unselected-checkbox'],
      fontSize: '0.5rem',
    },
    MuiStepConnector: {
      completed: {
        backgroundColor: styleVariablesJSON['primary-color'],
        height: '1.5px',
      },
      active: {
        backgroundColor: styleVariablesJSON['primary-color'],
        height: '1.5px',
      },
    },
    MuiDivider: {
      root: {
        backgroundColor: '#d0d0d0',
      },
    },
    MuiSelect: {
      icon: {
        color: styleVariablesJSON['input-text-color'],
      },
    },
  },
};
export default muiTheme;
